import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useSuperbillAnalyses from 'hooks/useSuperbillAnalyses';
import { superbillAnalysesSelectors } from "features/superbillAnalyses";

const SuperbillAnalysesList = () => {
  const { getSuperbillAnalyses } = useSuperbillAnalyses();
  const { data, pagination } = useCustomSelector(superbillAnalysesSelectors.getSuperbillAnalysesData);
  const fetching = useCustomSelector(superbillAnalysesSelectors.superbillAnalysesIsFetching);
  
  return (
    <BaseAnalysesList
      fetchData={getSuperbillAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <SuperbillAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);